module.exports = __webpack_public_path__ + "res/35-img_bg_l.1286b6900b32ee84ef1351e1afed92c3.png";